import { useLocation } from 'react-router';
import { QUERY_SEARCH_PARAM_PAGE } from '~/features/catalog/mappers/catalogSearchQueryMapper';
import {
  QUERY_SEARCH_PARAM_FILTER_ACTIONS,
  QUERY_SEARCH_PARAM_FILTER_SEARCH
} from '~/features/templates/hooks/useArticleListSearchFilter';
import { QUERY_SEARCH_PARAM_FILTER_GROUP } from '~/features/templates/hooks/useArticleListGroupFilter';

/**
 * This hook returns the URL query parameters that are used in the left navigation.
 * It filters out all other query parameters. This is useful when you want to create links to sites that should keep the current search/category selection state.
 */
export function useLeftNavigationUrlQueryParams() {
  const location = useLocation();

  const urlSearchParams = new URLSearchParams(location.search);
  urlSearchParams.delete(QUERY_SEARCH_PARAM_PAGE);

  // Remove article list specific filters
  urlSearchParams.delete(QUERY_SEARCH_PARAM_FILTER_SEARCH);
  urlSearchParams.delete(QUERY_SEARCH_PARAM_FILTER_ACTIONS);
  urlSearchParams.delete(QUERY_SEARCH_PARAM_FILTER_GROUP);

  return urlSearchParams;
}
